export default "__VITE_ASSET__CUhnEqtP__"